import type { GraphNode as NodeType } from "~/js/graph/node-socket-connection";
import { NodeEvents } from "~/js/types/IEventorListners";
import type { nodeNewExecutor } from "~/js/utilities/changeNodeExecutorOnCustom";
import type { INodeStartTrainingSchema } from "~/solidJs/shared/helpers/types/INodeDefinition";

export const extractAdditionalParamsFromTask = (
	extractParams: (jsonData: INodeStartTrainingSchema, node: NodeType) => void
) => {
	const exec: nodeNewExecutor = (node, layout, initialExecutor) => {
		initialExecutor(node, layout);

		node.eventor.addListener(NodeEvents.InputsChange, () => {
			node.meta.taskID = null;
		});

		node.eventor.addListener(NodeEvents.SuccessfullExecute, () => {
			node.meta.taskID = node.taskID;
		});

		node.getAdditionalParamsForTask = (jsonData) => {
			if (!node.meta.taskID) return;
			extractParams(jsonData, node);
		};
	};
	return exec;
};

export const midjourneyExecutor = extractAdditionalParamsFromTask((jsonData, node) => {
	jsonData.inputs.push({
		name: "task_id",
		value: `${node.meta.taskID}`,
		type: "text"
	});
});

export const midjourneyVariateExecutor: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "image_num",
				value: `${node.meta.fromImageIndex + 1}`,
				type: "text"
			}
		);
	};
};

export const midjourneyPan: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "image_num",
				value: `${node.meta.fromImageIndex + 1}`,
				type: "text"
			},
			{
				name: "pan_direction",
				value: `${node.meta.direction}`,
				type: "text"
			}
		);
	};
};

export const midjourneyZoomOut: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "image_num",
				value: `${node.meta.fromImageIndex + 1}`,
				type: "text"
			}
		);
	};
};

export const midjourneyGetId: nodeNewExecutor = (node, layout, initialExecutor) => {
	initialExecutor(node, layout);
	node.getAdditionalParamsForTask = (jsonData) => {
		jsonData.inputs.push(
			{
				name: "task_id",
				value: `${node.meta.fromTaskID}`,
				type: "text"
			},
			{
				name: "image_num",
				value: `${node.meta.fromImageIndex + 1}`,
				type: "text"
			}
		);
	};
};
